import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseFectch';

export const subscriptionApi = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getPlans: builder.query<any, void>({
      query: () => '/subscription/plans',
    }),
    getCurrentSubscription: builder.query<any, void>({
      query: () => '/subscription/current',
    }),
    createSubscription: builder.mutation<
      any,
      {
        planId: string;
        companyId: string;
        userId: string;
        interval?: string;
      }
    >({
      query: (body) => ({
        url: '/subscription/razor/subscribe',
        method: 'POST',
        body,
      }),
    }),
    verifySubscriptionPayment: builder.mutation<
      any,
      {
        razorpay_payment_id: string;
        razorpay_subscription_id: string;
        razorpay_signature: string;
      }
    >({
      query: (body) => ({
        url: '/subscription/razor/verify',
        method: 'POST',
        body,
      }),
    }),
    createStripePlan: builder.mutation<any, { planId: string }>({
      query: (body) => ({
        url: '/subscription/stripe/plan',
        method: 'POST',
        body,
      }),
    }),
    createStripeSubscription: builder.mutation<
      any,
      { planId: string; companyId: string; userId: string; interval?: string }
    >({
      query: (body) => ({
        url: '/subscription/stripe/subscribe',
        method: 'POST',
        body,
      }),
    }),
    verifyStripeSession: builder.mutation<any, { sessionId: string }>({
      query: ({ sessionId }) => ({
        url: `/subscription/stripe/verify-session/${sessionId}`,
        method: 'POST',
      }),
    }),
    createPayUSubscription: builder.mutation<
      any,
      {
        userId: string;
        companyId: string;
        planId: string;
        interval: string;
      }
    >({
      query: ({ userId, companyId, planId, interval }) => ({
        url: '/subscription/payu/subscribe',
        method: 'POST',
        body: {
          userId,
          companyId,
          planId,
          interval,
        },
      }),
    }),
    createPayPalSubscription: builder.mutation<
      any,
      {
        planId: string;
        companyId: string;
        userId: string;
        interval?: string;
      }
    >({
      query: (body) => ({
        url: '/subscription/paypal/subscribe',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGetPlansQuery,
  useGetCurrentSubscriptionQuery,
  useCreateSubscriptionMutation,
  useVerifySubscriptionPaymentMutation,
  useCreateStripePlanMutation,
  useCreateStripeSubscriptionMutation,
  useVerifyStripeSessionMutation,
  useCreatePayUSubscriptionMutation,
  useCreatePayPalSubscriptionMutation,
} = subscriptionApi;
